import {eq} from '@shared/helpers/lang'
import {createStateMaker} from '@shared/helpers/object'

import {ProductClass, ProductClassType} from '@web/core/constants'

import {OrderTotalState} from './interfaces'

export const getInitialState = (): OrderTotalState => ({
    amount: 0,
    deliveryFeeAmount: 0,
    safetyPurchaseAmount: 0,
    purchaserCommissionsByPayMethodType: null,
    cupDeposit: null,
    deposit: null,
    discountAmount: 0,
    productDiscountAmount: 0,
    deliveryDiscountAmount: 0,
})

export const makeMock = createStateMaker<OrderTotalState>(getInitialState)

/**
 * orderAmount를 계산하기 위한 공통 type
 */
type Product = {
    items: {
        /** 상품 아이템 타입 */
        productClassType: ProductClassType
        /** 아이템 번호 */
        itemNo: string
        /** 가격 */
        price: number
        /** 수량 */
        quantity: number
        /** 주문 금액 */
        orderAmount: number
        /** 옵션 컨텐츠 TEXT */
        optionContents: string
    }[]
}

export const getAmount = (products: Product[]): number => {
    return products
        .map((product) => {
            const {items} = product

            const {orderAmount, quantity} = items.reduce(
                (acc, next) => {
                    const eqProductClassType = eq(next.productClassType)
                    if (next.orderAmount) {
                        acc.orderAmount += next.orderAmount
                    }
                    if (!eqProductClassType(ProductClass.SUPPLEMENTED)) {
                        // 추가상품은 전체 수량에 포함되지 않는다.
                        acc.quantity += next.quantity
                    }
                    return {orderAmount: acc.orderAmount, quantity: acc.quantity}
                },
                {orderAmount: 0, quantity: 0},
            )
            return {
                // 상품 전체 수량
                quantity,
                // 상품 전체 금액
                orderAmount,
            }
        })
        .reduce((prev, {orderAmount}) => prev + orderAmount, 0)
}
